import { axios, Headers } from "../../../@core/auth/jwt/jwtService";
import { getPermissionsbyID, httpAddUserAddress, httpEditUserAddress, httpGetUserAddress, httpManageLogin, httpManageRegister, httpPostProfile, httpResetPass, httpResetPassReqCode, httpResetPassVerifyCode, httpSendCode, httpValidateEmail, httpVerifyCode } from "./ManageConstants";

  let URL = "https://maelano.info/api/v1"
  // let URL = "http://192.168.18.115:9000"


  // POST
const postManageHOF = (manageApi, data, id) => {
  const config = {
    headers: Headers,
    validateStatus: false
  };

    if (id) {
      return axios.post(`${URL}${manageApi}?id=${id}`, data, Headers);
    }
  
    return axios.post(`${URL}${manageApi}`, data, config)
    // .then(response => {
    //       console.log('Response::', response);
    //       return response; // returning the response for further processing if needed
    //     })
  };


// PUT
const putManageHOF = (manageApi, data, id) => {
  if (id) {
    return axios.put(`${URL}${manageApi}/${id}`, data, Headers);
  }

  return axios.put(`${URL}${manageApi}`, data, Headers)
};
const patchManageHOF = (manageApi, data, id) => {
  if (id) {
    return axios.patch(`${URL}${manageApi}/${id}`, data, Headers);
  }

  return axios.patch(`${URL}${manageApi}`, data, Headers)
};


// DELETE
const deleteManageHOF = (manageApi, data, id) => {
  if (id) {
    return axios.post(`${URL}${manageApi}?id=${id}`, data, Headers);
  }

  return axios.delete(`${URL}${manageApi}`, data, Headers);
};

// GET
// Get Manage HOF
const getManageHOF = async (manageApi) => {
    return axios.get(`${URL}${manageApi}`,Headers) 
}

// Dynamic ROUTING
const getUserRoutingByID = (data) => getManageHOF(`${httpUserRouting}/${data}`);






// LOGIN - REGISTER
const postManageLogin = (data, id) => postManageHOF(httpManageLogin, data, id);
const postManageRegister = (data, id) => postManageHOF(httpManageRegister, data, id);
const postValidateEmail = (data) => postManageHOF(httpValidateEmail, data);
const postSendCode = (data) => postManageHOF(httpSendCode, data);
const postVerifyCode = (data) => postManageHOF(httpVerifyCode, data);
const postResetPassReqCode = (data) => postManageHOF(httpResetPassReqCode, data)
const postResetPassVerifyCode = (data) => postManageHOF(httpResetPassVerifyCode, data)
const postResetPass = (data) => postManageHOF(httpResetPass, data)



// PERMISSIONS
const getPermissionbyID = (data) => postManageHOF(getPermissionsbyID, data);


// USER PORTAL
const postUserProfile = (data) => patchManageHOF(httpPostProfile, data);


const getAddress = () => getManageHOF(httpGetUserAddress);
const addAddress = (data) => postManageHOF(httpAddUserAddress, data);
const editAddress = (data, id) => patchManageHOF(`${httpEditUserAddress}/${id}`, data);


// Enterprise
// const getEnterprise = () => getManageHOF(httpGetEnterprise);
// const postEnterprise = (data) => postManageHOF(httpPostEnterprise, data);
// const putEntpStatus = (data) => putManageHOF(httpChangeEntpStatus, data);
// const putEnterprise = (data,id) => putManageHOF(`${httpPutEnterprise}/${id}`, data);
// const deleteManager = (id) => deleteManageHOF(`${httpDeleteManager}/${id}`)



export default {
    getUserRoutingByID, postManageLogin, postManageRegister, getPermissionbyID, postValidateEmail, postSendCode, postVerifyCode, postResetPassReqCode, postResetPassVerifyCode, postResetPass,

    // USER PORTAL
    postUserProfile,
    getAddress, addAddress, editAddress,

    // getEnterprise, postEnterprise, putEntpStatus, putEnterprise, deleteManager
}


